import { useContext, useEffect, useState } from 'preact/hooks';
import { SessionContext } from '../app.jsx';
import { get } from '../api.js';
import { Link } from '../router.js';
import { Tag } from '../ui/Tag.jsx';
import { guideNames } from './Calendar.jsx';
import { fmtRange, todayBelgrade } from '../../lib/dates.js';

function TourCard({ d, today }) {
  return (
    <article class="card" data-testid={`tour-card-${d.id}`}>
      <div class="card-head">
        <h3><Link href={`/ture/${d.id}`}>{d.tour.name}</Link></h3>
        {d.mine && d.end_date < today && <Tag kind="osteceno">Čeka popis</Tag>}
      </div>
      <p class="card-line">{fmtRange(d.start_date, d.end_date)}</p>
      <p class="card-line num">{d.people} ljudi</p>
      <p class="card-line">{guideNames(d.guides) ?? 'Još nema vodiča'}</p>
    </article>
  );
}

// Ture for a guide: their own tours first (with past ones awaiting inventory), then the rest.
export function ToursGuide() {
  const [list, setList] = useState(null);
  const [error, setError] = useState(null);
  const { tick } = useContext(SessionContext);
  useEffect(() => { get('/departures').then((r) => setList(r.departures), (e) => setError(e.message)); }, [tick]);
  const today = todayBelgrade();
  const mine = list?.filter((d) => d.mine) ?? [];
  const rest = list?.filter((d) => !d.mine) ?? [];
  return (
    <>
      <h1>Ture</h1>
      {error && <p class="alert" role="alert">{error}</p>}
      {list && list.length === 0 && <p class="empty">Nema zakazanih tura. Kancelarija ih dodaje u Ture.</p>}
      {list && list.length > 0 && (
        <>
          <section class="section" aria-labelledby="moje-ture">
            <h2 id="moje-ture">Moje ture</h2>
            {mine.length === 0 && <p class="empty">Još nisi ni na jednoj turi. Prijavi se ispod ili u kalendaru.</p>}
            {mine.map((d) => <TourCard key={d.id} d={d} today={today} />)}
          </section>
          {rest.length > 0 && (
            <section class="section" aria-labelledby="ostale-ture">
              <h2 id="ostale-ture">Ostale ture</h2>
              {rest.map((d) => <TourCard key={d.id} d={d} today={today} />)}
            </section>
          )}
        </>
      )}
    </>
  );
}
